var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10352e-05 0.999992C6.10352e-05 0.447712 0.447773 0 1.00005 0H8C8.55228 0 8.99999 0.447712 8.99999 0.999992V7.99993C8.99999 8.55221 8.55228 8.99993 8 8.99993H1.00005C0.447773 8.99993 6.10352e-05 8.55221 6.10352e-05 7.99993V0.999992ZM2.00004 1.99998V6.99994H7V1.99998H2.00004Z",
    fill: "#F4F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0.999992C11 0.447712 11.4477 0 12 0H18.9999C19.5522 0 19.9999 0.447712 19.9999 0.999992V7.99993C19.9999 8.55221 19.5522 8.99993 18.9999 8.99993H12C11.4477 8.99993 11 8.55221 11 7.99993V0.999992ZM13 1.99998V6.99994H17.9999V1.99998H13Z",
    fill: "#F4F7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 12C11 11.4477 11.4477 11 12 11H18.9999C19.5522 11 19.9999 11.4477 19.9999 12V18.9999C19.9999 19.5522 19.5522 19.9999 18.9999 19.9999H12C11.4477 19.9999 11 19.5522 11 18.9999V12ZM13 13V17.9999H17.9999V13H13Z",
    fill: "#F4F7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.10352e-05 12C6.10352e-05 11.4477 0.447773 11 1.00005 11H8C8.55228 11 8.99999 11.4477 8.99999 12V18.9999C8.99999 19.5522 8.55228 19.9999 8 19.9999H1.00005C0.447773 19.9999 6.10352e-05 19.5522 6.10352e-05 18.9999V12ZM2.00004 13V17.9999H7V13H2.00004Z",
    fill: "#F4F7FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveDashboardIcon);
export default __webpack_public_path__ + "static/media/activeDashboardIcon.ed6acd261470a35df3df691fb807c66e.svg";
export { ForwardRef as ReactComponent };